import React from 'react';
import Search from './search';

const ComponentStateless = (props) => {
    return <Search />
}

export default ComponentStateless;